import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getReferralAnalyses = asyncThunkWrapper({ 
  model: 'referralAnalyses', 
  action: 'getReferralAnalyses', 
  func: async ({ offset = 0 }) => {
    const attributes = ['id', 'status', 'updated_at'];
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get('/referral_flow/referral_analyses', { params });

    return response.data;
  } 
});
export const getReferralAnalysis = asyncThunkWrapper({ 
  model: 'referralAnalyses', 
  action: 'getReferralAnalysis', 
  func: async ({ id, cable = false }) => {
    const attributes = ['id', 'result', 'status', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/referral_analyses/${id}`, { params });

    return { data: response.data, cable };
  } 
});
export const clearLocalReferralAnalyses = createAction('referralAnalyses/clearLocalReferralAnalyses');
export const clearLocalActiveReferralAnalysis = createAction('referralAnalyses/clearLocalActiveReferralAnalysis');